export const convertRialToToman = (value: number): number => {
  if (!value) {
    return 0;
  }
  return value / 10;
};

export const convertTomanToRial = (value: number): number => {
  if (!value) {
    return 0;
  }
  return value * 10;
};

export const discountPrice = (value: number, discount: number) => {
  if (!discount) {
    return value;
  }
  if (!value) {
    return 0;
  }
  return value - (value * discount) / 100;
};

export const pickProductsItemQuantity = (item: any) => {
  if (item?.referenceNumber) {
    return 1;
  } else if (item?.alternativeProducts) {
    return item?.alternativeProducts?.quantity as number;
  } else {
    return item?.quantity as number;
  }
};

export const getDecimalAsString = (num: number) => {
  const parts = num.toString().split('.');
  return parts.length > 1 ? '.' + parts[1] : '0';
};
